var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-acc"},[_c('div',{staticClass:"title"},[_vm._v("让世界更智慧")]),_vm._v(" "),_c('div',{staticClass:"content"},[_vm._v("\n    立足于算法自主创新与认知智能技术前沿，赋能企业智能化转型。\n  ")]),_vm._v(" "),(_vm.checkSection == 1)?_c('img',{staticClass:"footer",attrs:{"src":_vm.footer,"alt":"人工智能大会"},on:{"click":_vm.goPath}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b4a7ece","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/home/home_acc.vue
// module id = null
// module chunks = 